import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fht-manager-modal',
  templateUrl: './fht-manager-modal.component.html',
  styleUrls: ['./fht-manager-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FhtManagerModalComponent {
  constructor(public dialogRef: MatDialogRef<FhtManagerModalComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
